<template>
    <div id="reward_category_section">
        <div id="reward_category_list"
            v-if="isHaveItem">
            <RewardCategoryItem
                v-for="(category, k) in categoryList"
                :key="k"
                :category="category"
                :isAmbassadorCategory="isAmbassadorCategory"
                @clickCategory="clickCategory($event)" />
        </div>
        <div id="reward_category_list_empty"
            v-if="!isHaveItem">
            <div class="icon-gift-nodata">
                <img src="../../../../assets/icon/mass/ic-gift@2x.png" v-show="theme == 'mass'">
                <img src="../../../../assets/icon/prestige/ic-gift@2x.png" v-show="theme == 'prestige'">
            </div>
            <div class="text-gift-nodata"
                :class="[{'color-mass': theme == 'mass'}, {'color-prestige': theme == 'prestige'}]">
                    {{lbl.reward.no_data}}
                </div>
        </div>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js"
//component
import RewardCategoryItem from './RewardCategoryItem.vue';
export default {
    name: 'RewardCategoryList',
    components: {
        RewardCategoryItem
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        isHaveItem: function () {
            return this.categoryList.length > 0 ? this.category.campaign_count : false;
        }
    },
    props: {
        category: { type: Object },
        categoryList: { type: Array },
        isAmbassadorCategory: { type: Boolean },
        trackingService: { type:Object }
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
        };
    },
    methods: {
        clickCategory: function (categoryInfo) {
            let eventName = 'click_subcategory_list';
            let tracking_label = categoryInfo.category.id + '|' + categoryInfo.category.name;
            this.trackingService.event('subcategory_list', eventName, tracking_label, null)
            this.$router.push(`/reward/${this.category.id}/sub/${categoryInfo.category.id}`);
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#reward_category_section {
    padding: {
        top: 15px;
        left: 15px;
        right: 15px;
        bottom: 40px;
    };

    @media (max-width: $max-width-mini-mobile) {
        padding: {
            top: 15px;
            left: 15px;
            right: 15px;
            bottom: 30px;
        };
    }
}

#reward_category_list_empty{
    text-align: center;

    .icon-gift-nodata{
        margin: {
            top: 120px;
            bottom: 15px;
        };
        img{
            width: 50px;
        }
    }
    .text-gift-nodata{
        &.color-mass{
            color: $mass_detail_font_color;
        }
        &.color-prestige{
            color: $prestige_gold_color;
        }
    }
}
</style>
